/* ============================================================
   Zampe & Cuori — header behaviour
   - Sticky header gets `is-scrolled` after the page is moved.
   - Mobile menu drawer: open/close, ESC, click outside, focus trap.
   ============================================================ */
(function () {
  'use strict';

  // ---- Sticky scroll state ---------------------------------------------
  const header = document.querySelector('[data-zc-header]');
  if (header) {
    const SCROLL_THRESHOLD = 8;
    let ticking = false;

    const updateState = () => {
      const scrolled = window.scrollY > SCROLL_THRESHOLD;
      header.classList.toggle('is-scrolled', scrolled);
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(updateState);
          ticking = true;
        }
      },
      { passive: true }
    );

    updateState();
  }

  // ---- Mobile menu drawer ---------------------------------------------
  const drawer = document.querySelector('[data-zc-drawer]');
  const openers = document.querySelectorAll('[data-zc-drawer-open]');
  const closers = drawer ? drawer.querySelectorAll('[data-zc-drawer-close]') : [];
  const overlay = drawer ? drawer.querySelector('[data-zc-drawer-overlay]') : null;

  if (drawer && openers.length) {
    const FOCUSABLE = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');

    let lastFocus = null;

    const openDrawer = (trigger) => {
      lastFocus = trigger || document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('zc-drawer-open');
      const firstFocusable = drawer.querySelector(FOCUSABLE);
      if (firstFocusable) firstFocusable.focus();
      document.addEventListener('keydown', handleKey);
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('zc-drawer-open');
      document.removeEventListener('keydown', handleKey);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    };

    const handleKey = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = drawer.querySelectorAll(FOCUSABLE);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    openers.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        openDrawer(btn);
      });
    });

    closers.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        closeDrawer();
      });
    });

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    // Tap su link interno al drawer (sia top-level sia sub-link
    // dell'accordion) → chiudi drawer. La navigazione segue il
    // comportamento nativo del browser. Click su <summary> non
    // matcha (è non-<a>), quindi il toggle accordion resta libero
    // di aprire/chiudere senza chiudere il drawer.
    drawer.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        closeDrawer();
      }
    });

    drawer.setAttribute('aria-hidden', 'true');
  }
})();
